const Notice = {
  'pages_notice_list.page_title': '공지 사항',
  'pages_notice_list.all': '전체',
  'pages_notice_list.title': '제목',
  'pages_notice_list.content': '내용',
  'pages_notice_list.hit': '조회수',
  'pages_notice_list.visible': '노출여부',
  'pages_notice_list.creatorId': '등록아이디',
  'pages_notice_list.created': '등록일시',
  'pages_notice_list.visible_true': '노출',
  'pages_notice_list.visible_false': '미노출',
  'pages_notice_list.create_button': '공지사항 생성',

  'pages_notice.path': '공지 사항',

  'pages_notice.show': '노출',
  'pages_notice.no_show': '미노출',
  'pages_notice_info.path': '공지 사항 상세',
  'pages_notice_info.title': '제목',
  'pages_notice_info.content': '내용',
  'pages_notice_info.visible_yn': '노출 여부',
  'pages_notice_info.creatorId': '등록아이디',
  'pages_notice_info.created': '등록일시',
  'pages_notice_info.file': '등록파일',

  'pages_notice_info.edit': '수정',
  'pages_notice_info.path_edit': '공지 사항 수정',
  'pages_notice_info.visible': '노출 변경',
  'pages_notice_info.visible_status': '노출 여부',
  'pages_notice_info.visible_true_text': '공지사항을 노출 하시겠습니까 ?',
  'pages_notice_info.visible_false_text': '공지사항을 미노출 하시겠습니까 ?',
  'pages_notice_info.delete_text': '공지사항을 삭제 하시겠습니까 ?',
  'pages_notice_info.delete': '삭제',


  'pages_notice_edit.create_confirm_message': '등록 하시겠습니까 ? ',
  'pages_notice_edit.edit_confirm_message': '수정 하시겠습니까 ? ',


  'pages_notice_create.title': '공지 사항 등록',
  'pages_notice_create.title_text': '공지 사항이 등록되었습니다.',
  'pages_notice_edit.title_text': '공지 사항이 수정되었습니다.',
  'pages_notice_delete.title_text': '공지 사항이 삭제되었습니다.',
  'pages_notice_create.file': '파일',

  'pages_notice_file.error': '에러가 발생했습니다.',
  'pages_notice_file.over_size': '파일 용량을 초과 하였습니다.',
  'pages_notice_file.not_allow_extenstion': '지원하지 않는 확장자입니다.',
  'pages_notice_file.list': '* 모든 첨부 파일은 최대 50MB까지 업로드 가능하며,PDF, 이미지(gif,jpg,jpeg,png), MS 오피스 파일(xls,xlsx,doc,docx,ppt,pptx) 및 zip 파일을 지원합니다.',


}

export default Notice




// WEBPACK FOOTER //
// ./src/lang/notice/Notice.kr.js